module.exports = __webpack_public_path__ + "img/watage_res_12.7e939c94.gif";